import React from 'react'
import { Link } from 'react-router'
import {
  Card,
  CardActions,
  CardHeader,
  CardText
} from 'material-ui/Card'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Dialog from 'material-ui/Dialog'
import RaisedButton from 'material-ui/RaisedButton'
import { get, map, partition, omit } from 'lodash'

import api from '../../../../api'
import ResourceDisplay from '../../../resource-display'
import UserSelect from './user-select'
import CreateSessionReservation from './create-session-reservation'

class OrderReservations extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      openDialog: false,
      assignments: {},
      assignmentErrors: {},
      isLoaded: false
    }
  }

  componentWillMount () {
    this.loadData().then(() => {
      this.setState({ isLoaded: true })
    })
  }

  loadData () {
    return this.loadReservations()
      .then(reservations => this.loadSessionSale(reservations))
  }

  loadOrderItems () {
    const body = {
      filters: {
        order_id: this.props.order.id
      }
    }

    return api.get('admin/order_items', { body })
      .then(res => res.json())
  }

  loadReservations () {
    const { order } = this.props
    const body = {
      filters: {
        order_id: order.id
      }
    }

    return api.get('admin/session_reservations', { body })
      .then(res => res.json())
      .then(reservations => {
        this.setState({ reservations })
        return reservations
      })
  }

  loadSessionSale (reservations) {
    if (reservations && reservations.length) {
      const path = `admin/session_sales/${reservations[0].session_sale_id}`
      return api.get(path)
        .then(res => res.json())
        .then(sessionSale => {
          this.setState({ sessionSale })
          return sessionSale
        })
    } else {
      return null
    }
  }

  reconcile = () => {
    api.post(`admin/orders/${this.props.order.id}/reconcile_reservations`)
      .then(res => res.json())
      .then(order => {
        this.props.onOrderChanged(order)
        this.loadReservations()
      })
  }

  handleUserAssignment = (reservation, user) => {
    if (user) {
      this.setState(prevState => ({
        ...prevState,
        assignments: {
          ...prevState.assignments,
          [reservation.id]: user.id
        }
      }))
    } else {
      this.setState(prevState => ({
        ...prevState,
        assignments: omit(prevState.assignments, reservation.id)
      }))
    }
  }

  handleReservationSave = () => {
    const promises = map(this.state.assignments, (userId, reservationId) => {
      const body = { user_id: userId }
      return api.patch(`admin/session_reservations/${reservationId}`, { body })
        .then(res => {
          if (res.ok) {
            return res.json()
          } else if (res.status === 400) {
            return res.json().then(body => {
              const errorMessage = get(body, 'errors.user_id', [])
              this.setState(prevState => ({
                ...prevState,
                assignmentErrors: {
                  ...prevState.assignmentErrors,
                  [reservationId]: errorMessage.join(', ')
                }
              }))
            })
          }
        })
    })

    Promise.all(promises).then(() => {
      this.loadReservations()
    })
  }

  openSessionDialog = () => {
    this.setState({ openDialog: true })
  }

  handleSessionReservationCreated = reservation => {
    this.props.onOrderChanged()
    this.setState({
      openDialog: false,
      reservations: this.state.reservations.concat(reservation)
    })
  }

  closeDialog = () => {
    this.setState({
      openDialog: false
    })
  }

  render () {
    if (!this.state.isLoaded) {
      return null
    }

    const { reservations, assignments, assignmentErrors } = this.state
    const { order } = this.props

    if (!reservations.length) {
      return (
        <Card>
          <CardHeader title='Session Reservations' />
          <CardActions>
            <RaisedButton
              primary
              label='Create a Session Reservation'
              onClick={this.openSessionDialog}
            />
            <Dialog
              modal={false}
              open={this.state.openDialog}
            >
              <CreateSessionReservation
                order={order}
                onSessionReservationCreated={this.handleSessionReservationCreated}
                onSessionReservationCanceled={this.closeDialog}
              />
            </Dialog>
          </CardActions>
        </Card>
      )
    }

    const singleUserReservation = reservations.length === 1 &&
      reservations.every(res => res.institution_id === null)
    const [assigned, unassigned] = partition(reservations, res => !!res.user_id)
    const showFinalize = order.order_status === 'open'
    // @ts-ignore
    const assignmentsChanged = Object.keys(assignments, assignmentErrors).length > 0

    if (singleUserReservation) {
      const [reservation] = reservations
      return (
        <Card>
          <CardHeader title='Session Reservation' />
          <CardText>
            <Table selectable={false}>
              <TableBody displayRowCheckbox={false}>
                <TableRow>
                  <TableRowColumn>Session</TableRowColumn>
                  <TableRowColumn>
                    <ResourceDisplay
                      path='admin/session_sales'
                      filters={{ id: reservation.session_sale_id }}
                      display='title'
                      link={res => `/events/session-sales/${reservation.session_sale_id}/summary`}
                    />
                  </TableRowColumn>
                </TableRow>
                <TableRow>
                  <TableRowColumn>Reservation</TableRowColumn>
                  <TableRowColumn>
                    <Link to={`/events/session-sales/${reservation.session_sale_id}/reservations/${reservation.id}/edit`}>
                      Reservation #{reservation.id}
                    </Link>
                  </TableRowColumn>
                </TableRow>
              </TableBody>
            </Table>
          </CardText>
          <CardActions>
            <RaisedButton
              primary
              label='Create a Session Reservation'
              onClick={this.openSessionDialog}
            />
            <Dialog
              modal={false}
              open={this.state.openDialog}
            >
              <CreateSessionReservation
                order={order}
                onSessionReservationCreated={this.handleSessionReservationCreated}
                onSessionReservationCanceled={this.closeDialog}
              />
            </Dialog>
          </CardActions>
        </Card>
      )
    }

    return (
      <Card>
        <CardHeader title='Session Sale Reservations' />
        <CardText>
          <Table>
            <TableBody displayRowCheckbox={false}>
              <TableRow>
                <TableRowColumn>
                  Number of reservations assigned
                </TableRowColumn>
                <TableRowColumn>
                  {assigned.length}
                </TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>
                  Number of reservations unassigned
                </TableRowColumn>
                <TableRowColumn>
                  {unassigned.length}
                </TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>
                  Total number of reservations
                </TableRowColumn>
                <TableRowColumn>
                  {reservations.length}
                </TableRowColumn>
              </TableRow>
            </TableBody>
          </Table>

          <Card>
            <CardHeader
              title={`Reservations (${reservations.length})`}
              subtitle='Click to expand'
              actAsExpander
              showExpandableButton
            />
            <CardText expandable>
              <Table selectable={false}>
                <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                  <TableRow>
                    <TableHeaderColumn>Session Sale</TableHeaderColumn>
                    <TableHeaderColumn>Status</TableHeaderColumn>
                    <TableHeaderColumn>Assigned User</TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                  {reservations.map(reservation => (
                    <TableRow key={reservation.id}>
                      <TableRowColumn>
                        {
                          <ResourceDisplay
                            path='admin/session_sales'
                            filters={{ id: reservation.session_sale_id }}
                            display='title'
                            link={res => `/events/session-sales/${reservation.session_sale_id}/summary`}
                          />
                        }
                      </TableRowColumn>
                      <TableRowColumn>
                        {reservation.user_id ? 'Assigned' : 'Unassigned'}
                      </TableRowColumn>
                      <TableRowColumn>
                        {
                          reservation.user_id &&
                            <ResourceDisplay
                              path='admin/users'
                              filters={{ id: reservation.user_id }}
                              display={user => {
                                return `${user.name} (${user.email})`
                              }}
                              link={res => `/security/users/${res.id}/edit`}
                            />
                        }
                        {
                          !reservation.user_id &&
                            <UserSelect
                              institutionId={reservation.institution_id}
                              errorText={assignmentErrors[reservation.id]}
                              onSelection={user => {
                                this.handleUserAssignment(reservation, user)
                              }}
                            />
                        }
                      </TableRowColumn>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardText>
          </Card>

        </CardText>
        <CardActions>
          <RaisedButton
            primary
            label='Create a Session Reservation'
            onClick={this.openSessionDialog}
          />
          <Dialog
            modal={false}
            open={this.state.openDialog}
          >
            <CreateSessionReservation
              order={order}
              onSessionReservationCreated={this.handleSessionReservationCreated}
              onSessionReservationCanceled={this.closeDialog}
            />
          </Dialog>
          {showFinalize &&
            <RaisedButton
              label='Finalize Reservations'
              onClick={this.reconcile}
              primary
            />}
          {showFinalize &&
            <RaisedButton
              disabled={!assignmentsChanged}
              label='Save Assignments'
              onClick={this.handleReservationSave}
            />}
        </CardActions>
      </Card>
    )
  }
}

// @ts-ignore
OrderReservations.propTypes = {
  order: React.PropTypes.object,
  onOrderChanged: React.PropTypes.func.isRequired
}

export default OrderReservations
